<template>
  <div>
    <!-- Confirmation Dialog -->
    <v-dialog :value="showConfirmDialog" @input="$emit('update:showConfirmDialog', $event)" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Επιβεβαίωση
        </v-card-title>
        <v-card-text>
          Είστε σίγουροι ότι θέλετε να {{ confirmAction === 'close' ? 'κλείσετε' : 'ανανεώσετε' }} το Συγκεντρωτικό Δελτίο Αποστολής;
          <div class="mt-2" v-if="confirmAction === 'close'">
            <span class="text--secondary">Με το κλείσιμο, όλα τα προϊόντα επιστρέφουν στην αποθήκη.</span>
          </div>
          <div class="mt-2" v-else-if="confirmAction === 'refresh'">
            <span class="text--secondary">Με την ανανέωση, το συγκεντρωτικό κλείνει και εκδίδεται νέο με το ίδιο απόθεμα που έχετε τώρα στην .</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" :loading="loading" @click="$emit('confirm-action')">Ναι, Συνέχεια</v-btn>
          <v-btn color="grey" text @click="$emit('update:showConfirmDialog', false)">Άκυρο</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Result Message Dialog -->
    <v-dialog :value="showResultDialog" @input="$emit('update:showResultDialog', $event)" max-width="400">
      <v-card>
        <v-card-title class="headline">Αποτέλεσμα</v-card-title>
        <v-card-text>
          <v-alert :type="resultType || 'info'" outlined>
            {{ resultMessage }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="$emit('reset-result-dialog')">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'SDADialogs',
  props: {
    showConfirmDialog: {
      type: Boolean,
      default: false
    },
    showResultDialog: {
      type: Boolean,
      default: false
    },
    confirmAction: {
      type: String,
      default: null
    },
    resultMessage: {
      type: String,
      default: ''
    },
    resultType: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
}
</script> 